export const questionLibraryConstants = {
  SET_FIELD_TYPE: 'SET_FIELD_TYPE',
  CANCEL: 'CANCEL',
  SET_TEXT: 'SET_TEXT',
  SET_CHOICE_TYPE: 'SET_CHOICE_TYPE',
  QUESTION_SET_SUPPORT_IMAGE: 'QUESTION_SET_SUPPORT_IMAGE',
  QUESTION_SET_SUPPORT_LINK: 'QUESTION_SET_SUPPORT_LINK',

  ADD_OPTION: 'ADD_OPTION',
  REMOVE_OPTION: 'REMOVE_OPTION',
  UPDATE_OPTION: 'UPDATE_OPTION',

  SAVE_QUESTION_REQUEST: 'SAVE_QUESTION_REQUEST',
  SAVE_QUESTION_SUCCESS: 'SAVE_QUESTION_SUCCESS',
  SAVE_QUESTION_FAILURE: 'SAVE_QUESTION_FAILURE',

  GETALL_QUESTIONS_REQUEST: 'GETALL_QUESTIONS_REQUEST',
  GETALL_QUESTIONS_SUCCESS: 'GETALL_QUESTIONS_SUCCESS',

  GET_QUESTION_REQUEST: 'GET_QUESTION_REQUEST',
  GET_QUESTION_SUCCESS: 'GET_QUESTION_SUCCESS',

  CANCEL_EDIT: 'CANCEL_EDIT',

  QUESTION_SET_PROMPT_WARNING: 'QUESTION_SET_PROMPT_WARNING',

  QUESTION_INIT_STATE: 'QUESTION_INIT_STATE'
}